import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';

const MaskedInput = ({
  mask,
  onChange,
  disabled,
  label,
  asterisk,
 backgroundColor = '',
  ...rest
}) => {
  const [isInputFilled, setInputFilled] = useState(false);

  const handleMaskedInputChange = (e) => {
    const { value } = e.target;
    setInputFilled(value !== '');

    const numericValue = value.replace(/\D/g, '');

    if (onChange) {
      onChange(numericValue);
    }
  };

  useEffect(() => {
    if (rest.value) {
      setInputFilled(true);
    }
  }, [rest.value]);

  return (
    <div
      className={`vert-input-container vert-input vert-input-number-spot ${
        disabled ? 'disabled' : ''
      }`}
      style={{
        backgroundColor: disabled ? 'var(--bg-color-disabled-input)' : backgroundColor,
        border: disabled ? '1px solid var(--color-border)' : '',
      }}
    >
      <label
        htmlFor="masked-input"
        className={`vert-input-label-spot ${
          isInputFilled ? 'shrink-label' : ''
        }`}
      >
        {label}
        {asterisk && <span className="asterisk">*</span>}
      </label>

      <InputMask
        mask={mask}
        onChange={handleMaskedInputChange}
        {...rest}
        disabled={disabled}
      />
    </div>
  );
};

export default MaskedInput;

MaskedInput.propTypes = {
  mask: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  asterisk: PropTypes.bool,
  backgroundColor: PropTypes.string,
};
